export default function PaySlipIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={18}
        height={18}
        x={0}
        y={0}
        viewBox="0 0 48 48"
        // style={{ enableBackground: 'new 0 0 512 512' }}
        xmlSpace="preserve"
      >
        <g>
          <path
            d="M41.179 11.116h-38.4A2.782 2.782 0 0 0 0 13.895v24.252a2.782 2.782 0 0 0 2.779 2.78h38.4a2.782 2.782 0 0 0 2.779-2.78V13.895a2.782 2.782 0 0 0-2.78-2.78zm1.263 27.031c0 .697-.566 1.264-1.263 1.264h-38.4a1.264 1.264 0 0 1-1.263-1.264V13.895c0-.697.566-1.263 1.263-1.263h38.4c.697 0 1.263.566 1.263 1.263v24.252zM48 9.853v24.252c0 .998-.518 1.896-1.387 2.403a.757.757 0 1 1-.764-1.309c.398-.232.635-.64.635-1.094V9.853c0-.697-.566-1.264-1.263-1.264h-38.4c-.453 0-.861.238-1.093.635a.759.759 0 0 1-1.31-.764 2.758 2.758 0 0 1 2.403-1.386h38.4A2.782 2.782 0 0 1 48 9.853zM4.8 23.747h9.095c.418 0 .758-.34.758-.757v-7.074a.758.758 0 0 0-.758-.758H4.8a.758.758 0 0 0-.758.758v7.074c0 .418.34.757.758.757zm5.305-1.515V20.21h3.032v2.02zm3.032-3.537h-3.032v-2.021h3.032zm-7.58-2.021H8.59v5.558H5.558zm33.6-1.516H25.012a.758.758 0 0 0-.758.758v4.042c0 .418.34.758.758.758h14.147c.418 0 .758-.34.758-.758v-4.042a.758.758 0 0 0-.758-.758zM38.4 19.2H25.768v-2.526H38.4zM4.042 29.053c0-.419.34-.758.758-.758h4.042a.758.758 0 0 1 0 1.516H4.8a.758.758 0 0 1-.758-.758zm13.642 0c0 .418-.34.758-.758.758h-4.042a.758.758 0 0 1 0-1.516h4.042c.419 0 .758.34.758.758zm8.084 0c0 .418-.34.758-.758.758h-4.042a.758.758 0 0 1 0-1.516h4.042c.419 0 .758.34.758.758zm8.085 0c0 .418-.34.758-.758.758h-4.042a.758.758 0 0 1 0-1.516h4.042c.418 0 .758.34.758.758zm-16.169 5.052c0 .419-.34.758-.758.758H4.8a.758.758 0 0 1 0-1.516h12.126c.419 0 .758.34.758.758z"
            fill="#000000"
            opacity={1}
            data-original="#000000"
          />
        </g>
      </svg>
    </>
  );
}
